import * as React from "react";
import { User } from "../../userTypes";
import { Button, Grid, Tooltip } from "@material-ui/core";

type Props = {
  user: User;
  onUserChanged: (user: User) => void;
  onClick: (params?: any) => any;
  disabled: boolean;
  processingData: Boolean;
};

export default class ComplianceScreeningDataUpdateButton extends React.Component<
  Props
> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  render() {
    return (
      <Grid
        container
        spacing={16}
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
        style={{
          marginLeft: "12px",
        }}
      >
        <Grid item>
          {this.props.disabled === false &&
          this.props.processingData === false ? (
            <Button
              color="primary"
              variant="contained"
              onClick={this.props.onClick}
              disabled={this.props.disabled}
            >
              Save PIP/PEP/Country of residence/nationality data
            </Button>
          ) : (
            <Tooltip
              title="Update PIP/PEP/Country of residence/nationality data to save."
              placement="bottom-start"
            >
              <span>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.props.onClick}
                  disabled={this.props.disabled}
                >
                  Save PIP/PEP/Country of residence/nationality data
                </Button>
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item>
          <div>
            {this.props.processingData ? (
              <div>Waiting for response...</div>
            ) : null}
          </div>
        </Grid>
      </Grid>
    );
  }
}
